/**
 * @description This function is used to replace the `in_sale-[int numeric]` segment in the URL with `in_sale-on`.
 * @param {string} url The URL to be formatted
 * @return {string} The formatted URL
 */
const canonicalStringForOnSale = (url: string): string => {
  const regExpInSale = /in_sale-\d+/;
  const [path, queryParams] = url.split('?');
  const updatedPath = path
    .split('/')
    .map((segment) => segment.replace(regExpInSale, 'in_sale-on'))
    .join('/');

  return queryParams ? `${updatedPath}?${queryParams}` : updatedPath;
};

export default canonicalStringForOnSale;
